import { create } from 'zustand'

const handleCheckStation = (index, set) => {
  set((state) => {
    let newState = [...state.activeStations.map(station => ({ ...station }))];
    newState[index].checked = !newState[index].checked;
    return { activeStations: newState }
  })
}

const getSortedStations = (headers, get) => {
  const sortedStations = get(state => state.sortedStations) || [];
  let newColumns = headers;
  if (sortedStations.length) {
    newColumns = sortedStations.map(cur => cur.active && headers.find(header => header.id === cur)).filter(cur => cur);
  }
  return newColumns;
}

const setSortedStations = (stations, set) => {
  console.log(stations, "stations");
  set((prevStations) => {
    const newStations = [...stations.map((station) => ({ ...station }))];
    return { sortedStations: newStations };
  })
}

const useServiceDashboardStore = create((set, get) => ({
  activeStations: [],
  setActiveStations: (as) => set({ activeStations: as }),
  handleCheckStation: (index) => handleCheckStation(index, set),
  sortedStations: [],
  getSortedStations: (headers) => getSortedStations(headers, get),
  setSortedStations: (stations) => setSortedStations(stations, set)
}))

export default useServiceDashboardStore;